import { valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubEnumerated, valueType_Time, valueType_Tuple } from '../../../_entity/value/index.js';
import { inNormalRangeOperators, inRangeOperators, inSetOperators, LogicType_Equals, LogicType_Exists, LogicType_NotExists, LogicType_In, LogicType_IsChiefComplaint, LogicType_InSet, LogicType_IsFalse, LogicType_IsTrue, LogicType_NotEquals, LogicType_NotInSet, RightHandValues_NumericOperators, SelfOperators } from '../../../_enum.js';
//******* Atom level consts
export const EvaluationLogicTypes = {
    self: 'self',
    notEqual: 'not-equal',
    set: 'set',
    range: 'range',
    normalRange: 'normal-range',
    exists: 'exists',
    notExists: 'not-exists',
    isChiefComplaint: 'is-chief-complaint'
};
export const AllowedOperators = {
    [EvaluationLogicTypes.self]: SelfOperators,
    [EvaluationLogicTypes.notEqual]: [LogicType_NotEquals, LogicType_NotInSet],
    [EvaluationLogicTypes.set]: inSetOperators,
    [EvaluationLogicTypes.range]: inRangeOperators,
    [EvaluationLogicTypes.normalRange]: inNormalRangeOperators,
    [EvaluationLogicTypes.exists]: [LogicType_Exists],
    [EvaluationLogicTypes.notExists]: [LogicType_NotExists],
    [EvaluationLogicTypes.isChiefComplaint]: [LogicType_IsChiefComplaint]
};
export const StringDBValueTypes = [
    valueType_Enumerated,
    valueType_SubEnumerated,
    valueType_Tuple,
];
export const NumericDBValueTypes = [
    valueType_StandardRange,
    valueType_Range,
    valueType_Time
];
export const defaultFallback = [0, 0];
export const InSetOperators = [LogicType_Equals, LogicType_InSet, LogicType_IsTrue, LogicType_IsFalse];
export const RangeOperators = [LogicType_In, ...RightHandValues_NumericOperators];
//# sourceMappingURL=consts.js.map